import React from 'react';
import DefaultTheme from "./themes/DefaultTheme";
import ValsaborTheme from "./themes/ValsaborTheme";
import NutriavesTheme from "./themes/NutriavesTheme";
import MaporalTheme from "./themes/MaporalTheme";
import RaporalTheme from "./themes/RaporalTheme";

export const getTheme  = () => {
    const url = window.location.host;
    const tenant = url.split(".")[0];

    if(tenant.toLocaleLowerCase().includes(Tenants.NUTRIAVES.subDomain)) {
        return NutriavesTheme;
    }

    if(tenant.toLocaleLowerCase().includes(Tenants.VALSABOR.subDomain)) {
        return ValsaborTheme;
    }

    if(tenant.toLocaleLowerCase().includes(Tenants.MAPORAL.subDomain)) {
        return MaporalTheme;
    }

    if(tenant.toLocaleLowerCase().includes(Tenants.RAPORAL.subDomain)) {
        return RaporalTheme;
    }
    return ValsaborTheme;
};

export const getTenantId  = () => {
    const url = window.location.host;
    const tenant = url.split(".")[0];

    if(tenant.toLocaleLowerCase().includes(Tenants.NUTRIAVES.subDomain)) {
        return Tenants.NUTRIAVES.id;
    }

    if(tenant.toLocaleLowerCase().includes(Tenants.VALSABOR.subDomain)) {
        return Tenants.VALSABOR.id;
    }

    if(tenant.toLocaleLowerCase().includes(Tenants.MAPORAL.subDomain)) {
        return Tenants.MAPORAL.id;
    }

    if(tenant.toLocaleLowerCase().includes(Tenants.RAPORAL.subDomain)) {
        return Tenants.RAPORAL.id;
    }

    return Tenants.VALSABOR.id;
};

const Tenants = {
    NUTRIAVES: {
        id: "nutriavesTenant",
        subDomain: "nutriaves"
    },
    VALSABOR: {
        id: "valsaborTenant",
        subDomain: "valsabor"
    },
    MAPORAL: {
        id: "maporalTenant",
        subDomain: "maporal"
    },
    RAPORAL: {
        id: "raporalTenant",
        subDomain: "raporal"
    }
};

export const ThemeContext = React.createContext(DefaultTheme); //default Theme